import React, { useCallback, useState } from 'react';
import Header from '../layout/Header';
import SidebarNavbar from '../layout/SidebarNavbar';
import { Outlet } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

function Layout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMobileMenu = useCallback(() => setIsMobileMenuOpen(false), []);

  return (
    <div className="flex h-screen min-w-0 overflow-hidden">
      <SidebarNavbar
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={closeMobileMenu}
      />
      {isMobileMenuOpen && (
        <button
          type="button"
          aria-label="Cerrar menú"
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={closeMobileMenu}
        />
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <Header
          onMenuToggle={() => setIsMobileMenuOpen((open) => !open)}
          isMobileMenuOpen={isMobileMenuOpen}
        />
        <main className="min-w-0 flex-1 overflow-y-auto bg-gray-100 p-3 sm:p-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
